import React, { useState } from "react"
import { flowRight as compose } from "lodash"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { Card, CardBody } from "reactstrap"
import ReactTable from "react-table"
import { Link } from "react-router-dom"
import { useQuery } from "@apollo/react-hooks"
import { Spinner } from "components/spinner"
import withModal from "components/modal"
import { orderStatusTypes, findTypeValueByKey } from "utils/types"
import OrderClListOperation from "./OrderClListOperation"
import { GET_ORDERS, GET_TABLE_FIELDS, SUM_ORDERS } from "../gql"
import { CustomServerSideReactTableNew } from "../../../components/utility"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const OrderClListContainer = (props) => {
  useBread({ to: props.match.url, name: "訂單明細" }, true)

  const columnDefs = [
    { title: "巨研訂單編號", name: "orderNumber", type: "input" },
    { title: "公司訂單號碼", name: "clientOrderNumber", type: "input" },
    {
      title: "訂單狀態",
      name: "status",
      type: "select",
      options: orderStatusTypes
    }
  ]

  const fieldsDefinitions = (props) => {
    return [
      {
        Header: "id",
        accessor: "id",
        show: false
      },
      {
        id: "orderNumber",
        Header: "巨研訂單編號",
        style: columStyle,
        accessor: (data) => data.orderNumber,
        Cell: (cell) => {
          return (
            <Link to={`${props.match.url}/detail/${cell.row.id}`}>
              {cell.row.orderNumber || "未成立之訂單"}
            </Link>
          )
        }
      },
      {
        id: "clientOrderNumber",
        Header: "公司訂單號碼",
        style: columStyle,
        accessor: (data) => data.clientOrderNumber,
        Cell: (cell) => {
          return <div>{cell.row.clientOrderNumber}</div>
        }
      },
      {
        id: "user",
        Header: "訂購人",
        style: columStyle,
        accessor: (data) => data.user?.name,
        Cell: (cell) => {
          return <div>{cell.row.user}</div>
        }
      },
      {
        id: "totalAmount",
        Header: "訂單小計",
        style: columStyle,
        accessor: (data) => data.totalAmount,
        Cell: (cell) => {
          return <div>{cell.row.totalAmount || "須向業務確認價格"}</div>
        }
      },
      {
        id: "orderStatus",
        Header: "訂單狀態",
        style: columStyle,
        accessor: (data) => findTypeValueByKey(orderStatusTypes, data.status),
        Cell: (cell) => {
          return <div>{cell.row.orderStatus}</div>
        }
      }
    ]
  }

  return (
    <CustomServerSideReactTableNew
      columnDefs={columnDefs}
      queryObjectGql={GET_ORDERS}
      sumTotalQueryObjectGql={SUM_ORDERS}
      fieldsDefGql={GET_TABLE_FIELDS}
      objectRoute={props.match.url}
      fieldsDef={fieldsDefinitions(props)}
    />
  )
}
const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default compose(withBreadcrumb, withModal)(OrderClListContainer)
